import { ApplicationPermissionType } from "ui/Scripts/source/models/enums";

export interface IUnitModuleNodeUsageSave {
    applicationPermissionType: ApplicationPermissionType;
    inUse: boolean;
}

export class UnitModuleNodeUsageSave implements IUnitModuleNodeUsageSave {
    applicationPermissionType: ApplicationPermissionType;
    inUse: boolean;

    constructor();
    constructor(obj: IUnitModuleNodeUsageSave);
    constructor(obj?: any) {
        this.applicationPermissionType = obj && obj.applicationPermissionType || 0;
        this.inUse = obj && obj.inUse || false;
    }
}